export default "__VITE_ASSET__ce1aff30__"